<template>
  <div class="body">
    <div class="detay">
      <hr class="m-0">
      <div class="icerik" style="height: calc(100vh + 15px);">
        <div class="PanelGrafikBar">
          <el-row>
            <el-col :span="12">
             <PanelGrafik></PanelGrafik>
            </el-col>
            <el-col :span="5">
              <PanelCalendar></PanelCalendar>
            </el-col>
            <el-col :span="4" style="padding-left: 10px">
              <PanelFirsat></PanelFirsat>
            </el-col>
            <el-col :span="3">
              <PanelBand></PanelBand>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="5" style="padding-right: 10px">
            <div class="aiPanelDes">
              <div class="aiPanelHead" style="padding-bottom: 20px;">
                <svg id="Layer_1" enable-background="new 0 0 512.021 512.021" height="512" viewBox="0 0 512.021 512.021"
                     width="512" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="m166.977 417.964h-46.966c-22.091 0-40-17.909-40-40s17.909-40 40-40h60c-22.091 0-40 17.909-40 40 0 17.39 11.101 32.182 26.601 37.693.113.697.238 1.396.372 2.094-.002.071-.005.142-.007.213zm-26.269-238c-4.157 8.237-15.902 11.132-23.309 3.789l-29.081-28.828c-11.075-10.978-11.075-28.943 0-39.921l29.081-28.828c7.979-7.909 20.991-3.94 24.131 5.789h13.481v-40.482c0-27.929-34.078-42.007-53.876-22.382l-63.102 62.552c-24.031 23.821-24.031 62.801 0 86.622l63.102 62.552c19.798 19.625 53.876 5.547 53.876-22.382v-38.481z"
                      fill="#8996a0" opacity=".2"/>
                    <path
                      d="m389.278 512.021c-6.603 0-13.294-1.317-19.765-4.014-19.137-7.976-31.503-26.645-31.503-47.562v-42.481c0-11.046 8.954-20 20-20s20 8.954 20 20v42.481c0 7.011 4.819 9.776 6.892 10.64 1.993.831 7.146 2.255 11.904-2.462l63.102-62.551c7.805-7.737 12.103-18.074 12.103-29.107s-4.298-21.371-12.103-29.107l-63.102-62.552c-4.759-4.718-9.911-3.292-11.904-2.462-2.072.864-6.892 3.629-6.892 10.64v44.481c0 11.046-8.954 20-20 20h-238c-11.028 0-20 8.972-20 20s8.972 20 20 20h32c11.046 0 20 8.954 20 20s-8.954 20-20 20h-32c-33.084 0-60-26.916-60-60s26.916-60 60-60h218v-24.481c0-20.917 12.366-39.585 31.503-47.562 19.274-8.035 40.521-3.826 55.453 10.976l63.102 62.552c15.439 15.305 23.942 35.731 23.942 57.515s-8.503 42.21-23.942 57.515l-63.102 62.552c-9.918 9.831-22.625 14.989-35.688 14.989zm-246.028-246.116c19.591-8.165 31.761-26.351 31.761-47.46v-22.481h217c33.084 0 60-26.916 60-60s-26.916-60-60-60h-217v-24.481c0-21.109-12.17-39.295-31.761-47.46-19.343-8.062-41.4-3.793-56.195 10.874l-63.102 62.552c-15.44 15.305-23.942 35.731-23.942 57.515s8.503 42.21 23.942 57.515l63.102 62.552c9.829 9.743 22.861 14.897 36.174 14.897 6.727 0 13.528-1.317 20.021-4.023zm-15.389-224.96c2.149.896 7.149 3.716 7.149 10.539v44.481c0 11.046 8.954 20 20 20h237c11.028 0 20 8.972 20 20s-8.972 20-20 20h-237c-11.046 0-20 8.954-20 20v42.481c0 6.822-5 9.643-7.149 10.539-2.173.906-7.754 2.49-12.646-2.361l-63.102-62.552c-7.805-7.736-12.103-18.074-12.103-29.107s4.298-21.371 12.103-29.107l63.102-62.551c2.619-2.596 5.436-3.349 7.82-3.349 2.07-.001 3.816.566 4.826.987zm-89.828 50.708h.01z"
                      fill="#8996a0" opacity=".5"/>
                    <path
                      d="m282.01 437.964h-54c-11.046 0-20-8.954-20-20s8.954-20 20-20h54c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
                      fill="#f4b400"/>
                  </g>
                </svg>
                <h1 @click="ToplamGetir">
                  {{ this.$store.getters.Admin > 0 && this.$store.getters.Paket == 1 ? 'Özet' : 'Kasa' }}</h1>
              </div>
              <el-divider v-if="this.$store.getters.Admin>0 && this.$store.getters.Paket == 1" content-position="left">
                Kasa
              </el-divider>
              <mWidget
                :data="{isim: 'Bugün Kasa '+(this.$store.getters.Admin>0 && this.$store.getters.Paket == 1?'[Şirket]':''), sayi: this.Toplam.Bakiye, icon: 'feather-check-circle', renk: 'ins3  m-widget-buyuk m-widget-yeni'}"></mWidget>

              <mWidget
                :data="{isim: 'Bugün Tahsilat '+(this.$store.getters.Admin>0 && this.$store.getters.Paket == 1?'[Şirket]':''), sayi: this.Toplam.Tahsilat, icon: 'feather-arrow-down-circle', renk: 'ins1 m-widget-buyuk m-widget-yeni'}"></mWidget>
              <mWidget
                :data="{isim: 'Bugün Ödeme '+(this.$store.getters.Admin>0 && this.$store.getters.Paket == 1?'[Şirket]':''), sayi: this.Toplam.Odeme, icon: 'feather-arrow-up-circle', renk: 'ins2  m-widget-buyuk m-widget-yeni'}"></mWidget>
              <el-divider v-if="this.$store.getters.Admin>0 && this.$store.getters.Paket == 1" content-position="left">
                Portföy
              </el-divider>

              <mWidget v-if="this.$store.getters.Admin>0 && this.$store.getters.Paket == 1"
                       :data="{isim: 'Toplam Bina', sayi: this.Toplam.Bina, icon: 'feather-home', renk: 'ins6 m-widget-buyuk m-widget-yeni'}"></mWidget>
              <mWidget v-if="this.$store.getters.Admin>0 && this.$store.getters.Paket == 1"
                       :data="{isim: 'Toplam Mesken', sayi: this.Toplam.Mesken, icon: 'feather-grid', renk: 'ins7 m-widget-buyuk m-widget-yeni'}"></mWidget>
              <mWidget v-if="this.$store.getters.Admin>0 && this.$store.getters.Paket == 1"
                       :data="{isim: 'Toplam Abone', sayi: this.Toplam.Kisi, icon: 'feather-user', renk: 'ins8 m-widget-buyuk m-widget-yeni'}"></mWidget>
            </div>
          </el-col>
          <el-col :span="6" style="padding-right: 10px">
            <div class="aiPanelDes">
              <div class="aiPanelHead">
                <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                     xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="m203.029 135c0-51.123 33.362-94.446 79.5-109.407-11.182-3.625-23.11-5.593-35.5-5.593-63.513 0-115 51.487-115 115s51.487 115 115 115c12.39 0 24.318-1.968 35.5-5.593-46.138-14.961-79.5-58.284-79.5-109.407z"
                      fill="#8996a0" opacity=".2"/>
                    <g>
                      <path
                        fill="#8996a0" opacity=".5"
                        d="m256.029 270c74.439 0 135-60.561 135-135s-60.561-135-135-135-135 60.561-135 135 60.56 135 135 135zm0-230c52.383 0 95 42.617 95 95s-42.617 95-95 95-95-42.617-95-95 42.617-95 95-95z"/>
                      <path
                        fill="#8996a0" opacity=".5"
                        d="m505.803 381.875c-13.039-25.05-42.723-35.939-70.356-25.454-19.27 7.314-42.832 16.254-68.478 23.326 2.366-11.388 1.186-23.447-3.544-34.912-6.896-16.716-21.069-29.153-38.884-34.122-9.106-2.54-18.992-3.112-29.385-1.699-68.528 9.321-109.325-13.851-145.323-34.294-24.197-13.741-47.05-26.72-73.804-26.72-34 0-61.974 10.913-61.974 10.913-10.542 3.299-16.412 14.519-13.113 25.061 3.299 10.541 14.517 16.415 25.061 13.113 0 0 24.026-9.087 50.026-9.087 16.188 0 32.896 9.489 54.051 21.502 31.676 17.988 73.266 41.611 135.088 41.609 11.116 0 22.895-.765 35.378-2.462 4.89-.665 9.473-.46 13.249.593 4.216 1.176 9.833 4.013 12.654 10.848 2.188 5.302 2.297 10.263.324 14.746-2.419 5.499-7.933 10.056-15.522 12.831-10.955 4.005-25.494 6.139-43.222 6.333-19.013.14-38.59-2.053-54.917-6.343-10.683-2.808-21.62 3.578-24.427 14.261s3.578 21.619 14.261 24.426c19.119 5.024 42.083 7.657 64.083 7.657 75.998-.341 141.141-24.441 182.61-40.182 6.952-2.637 16.338-1.823 20.529 6.232 3.752 7.208 1.158 16.5-5.989 20.318-50.195 26.816-108.444 51.631-194.038 51.631-76.199 0-146.387-29.405-191.849-54.072-35.021-19.002-60.613-13-63.415-12.253l.012.045c-8.551 2.271-14.861 10.043-14.861 19.309 0 11.046 8.954 20 20 20 1.659 0 3.263-.224 4.804-.605 1.79-.306 14.732-2 34.383 8.662 49.534 26.876 126.335 58.914 210.926 58.914 107.407 0 178.649-38.06 212.886-56.35 26.394-14.101 36.618-47.185 22.776-73.775z"/>
                      <path d="m267.029 434c-.33.004.74 0 0 0z"/>
                    </g>
                    <path
                      d="m256.029 186c-11.046 0-20-8.954-20-20v-42c-11.046 0-20-8.954-20-20s8.954-20 20-20h20c11.046 0 20 8.954 20 20v62c0 11.046-8.955 20-20 20z"
                      fill="#f4b400"/>
                  </g>
                </svg>
                <h1>Finansal</h1>
              </div>
              <el-tabs class="tab-p0">
                <el-tab-pane :lazy=true>
                  <span slot="label"> Sanal Pos</span>
                  <PanelSanalPos></PanelSanalPos>
                </el-tab-pane>
                <el-tab-pane :lazy=true>
                  <span slot="label"> Bankalar</span>
                  <PanelBanka></PanelBanka>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="7" style="padding-right: 10px">
            <div class="aiPanelDes">
              <div class="aiPanelHead">
                <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                     xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="m321.897 42.346c.232-2.783.437-5.651.794-8.492-20.591-8.948-43.192-13.854-66.691-13.854-74.624 0-140.25 49.36-160.949 121.056l-24.523 174.944h-10.528c-22.091 0-40 17.909-40 40s17.909 40 40 40h93.415l4.884-20.388c-20.376.127-33.299-19.612-29.296-38.993l18.343-144.573c2.559-20.173 8.36-39.851 17.654-57.938 29.052-56.536 79.85-82.052 141-82.052 4.902 0 9.763.343 14.577.949.532-3.537 1.022-7.083 1.32-10.659z"
                      fill="#8996a0" opacity=".2"/>
                    <g fill="#8996a0" opacity=".5">
                      <path
                        d="m139 293c0 11.046 8.954 20 20 20h193c11.046 0 20-8.954 20-20s-8.954-20-20-20h-193c-11.046 0-20 8.954-20 20z"/>
                      <path
                        d="m458.919 296.396-6.612-47.173c-1.534-10.938-11.641-18.566-22.583-17.03-10.939 1.533-18.563 11.644-17.03 22.583l8.971 64c1.384 9.876 9.833 17.224 19.806 17.224h10.529c11.028 0 20 8.972 20 20s-8.972 20-20 20h-392c-11.028 0-20-8.972-20-20s8.972-20 20-20h10.528c9.973 0 18.422-7.347 19.806-17.224l21.532-153.607c5.801-41.38 28.616-78.044 62.596-100.589 24.238-16.08 52.538-24.58 83.538-24.58 19.467.402 38.671 4.236 54.954 11.334 10.126 4.413 21.912-.217 26.326-10.342s-.217-21.912-10.342-26.326c-21.094-9.194-43.938-14.666-70.938-14.666-36.997 0-74.839 10.806-105.651 31.249-43.513 28.87-72.706 75.658-80.094 128.368l-19.174 136.78c-29.836 3.442-53.081 28.859-53.081 59.603 0 33.084 26.916 60 60 60h392c33.084 0 60-26.916 60-60 0-30.744-23.245-56.161-53.081-59.604z"/>
                    </g>
                    <path
                      d="m257 512c-30.477 0-56.094-22.652-59.586-52.69-1.276-10.972 6.584-20.9 17.556-22.176 10.972-1.282 20.9 6.584 22.176 17.556 1.147 9.868 9.683 17.31 19.854 17.31s18.707-7.442 19.854-17.31c1.276-10.972 11.211-18.83 22.176-17.556 10.972 1.276 18.832 11.205 17.556 22.176-3.492 30.038-29.109 52.69-59.586 52.69zm235-432h-60v-60c0-11.046-8.954-20-20-20s-20 8.954-20 20v60h-60c-11.046 0-20 8.954-20 20s8.954 20 20 20h60v60c0 11.046 8.954 20 20 20s20-8.954 20-20v-60h60c11.046 0 20-8.954 20-20s-8.954-20-20-20z"
                      fill="#f4b400"/>
                  </g>
                </svg>
                <h1>Bildirim</h1>
              </div>
              <el-tabs class="tab-p0" v-model="AktifTakvim">
                <el-tab-pane name="Tab0" :lazy=true>
                  <span slot="label"> Gecikmiş</span>
                  <PanelTakvim :Mod="0"></PanelTakvim>
                </el-tab-pane>
                <el-tab-pane name="Tab1" :lazy=true>
                  <span slot="label"> Bugün</span>
                  <PanelTakvim :Mod="1"></PanelTakvim>
                </el-tab-pane>
                <el-tab-pane name="Tab2" :lazy=true>
                  <span slot="label"> Bu Hafta</span>
                  <PanelTakvim :Mod="2"></PanelTakvim>
                </el-tab-pane>
                <el-tab-pane name="Tab3" :lazy=true>
                  <span slot="label"> Bu Ay</span>
                  <PanelTakvim :Mod="3"></PanelTakvim>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="aiPanelDes">
              <div class="aiPanelHead">
                <svg id="Layer_1" enable-background="new 0 0 512.133 512.133" height="512" viewBox="0 0 512.133 512.133"
                     width="512" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                      d="m178.124 486.962-3.058 5.038s-136 7-136-83c0-92 119.117-132.294 156-145 8.056-2.775 22.421-6.82 39.952-12.408 2.617 5.55 5.165 11.13 7.655 16.735-45.802 16.399-143.607 57.308-143.607 140.673 0 49.899 41.803 69.973 79.058 77.962zm137.392-7.117 18.876-85.508c4.824-24.134 16.685-46.3 34.088-63.704l35.408-35.408c-15.123-1.374-30.722 3.722-42.299 15.299l-61.109 61.109c-17.403 17.403-29.264 39.569-34.088 63.704l-11.326 56.663s59.193-11.863 60.45-12.155z"
                      fill="#8996a0" opacity=".2"/>
                    <path
                      d="m490.685 256.381c-13.789-13.788-32.121-21.381-51.619-21.381-19.499 0-37.831 7.593-51.619 21.381l-101.109 101.109c-20.263 20.264-33.941 45.827-39.558 73.926l-11.326 56.664c-1.311 6.557.742 13.334 5.47 18.063 3.788 3.787 8.891 5.857 14.143 5.857 1.304 0 2.616-.127 3.92-.388l56.664-11.326c28.099-5.616 53.662-19.295 73.926-39.558l101.108-101.109c13.788-13.788 21.382-32.12 21.382-51.619s-7.594-37.831-21.382-51.619zm-28.285 74.953-101.109 101.109c-14.659 14.66-33.152 24.556-53.48 28.618l-27.253 5.447 5.447-27.253c4.063-20.328 13.958-38.821 28.618-53.48l101.109-101.11c6.232-6.232 14.52-9.665 23.334-9.665s17.102 3.433 23.335 9.666c6.232 6.232 9.665 14.52 9.665 23.334s-3.432 17.102-9.666 23.334zm-246.486-53.036c-5.837 1.836-11.756 3.724-15.213 4.914-35.031 12.062-141.635 48.77-141.635 125.788 0 14.89 4.815 26.715 14.721 36.149 26.023 24.786 81.223 27.806 100.278 26.876 11.042-.55 20.41 7.955 20.962 18.975.552 11.021-7.912 20.406-18.933 20.974-.583.03-3.373.159-7.82.159-22.15 0-85.43-3.212-121.98-37.93-18.066-17.16-27.228-39.098-27.228-65.203 0-25.238 7.551-49.001 22.441-70.629 11.89-17.267 28.605-33.284 49.685-47.606 36.256-24.634 77.81-38.943 97.36-45.674 3.968-1.367 9.248-3.027 15.362-4.95 27.312-8.589 73.023-22.964 112.232-44.797 43.077-23.987 64.919-49.461 64.919-75.715 0-29.962-14.196-48.885-26.106-59.483-13.75-12.239-32.55-20.146-47.893-20.146-11.046 0-20-8.954-20-20s8.954-20 20-20c25.346 0 53.191 11.313 74.485 30.263 25.481 22.676 39.515 54.413 39.515 89.365 0 94.154-143.762 139.364-205.152 158.67z"
                      fill="#8996a0" opacity=".5"/>
                    <path
                      d="m110.066 124c-42.119 0-67.86-17.885-82.037-32.889-17.77-18.808-27.963-44.727-27.963-71.111 0-11.046 8.954-20 20-20s20 8.954 20 20c0 30.824 21.905 64 70 64 34.555 0 56.37-17.156 81.63-37.021 7.829-6.157 15.924-12.523 24.61-18.505 9.097-6.264 21.55-3.97 27.816 5.127 6.265 9.097 3.97 21.55-5.127 27.815-7.645 5.265-14.896 10.967-22.573 17.005-27.165 21.364-57.956 45.579-106.356 45.579z"
                      fill="#f4b400"/>
                  </g>
                </svg>
                <h1>Takip</h1>
              </div>
              <el-tabs class="tab-p0">
                <el-tab-pane :lazy=true>
                  <span slot="label"> Anımsatıcı</span>
                  <PanelTodo></PanelTodo>
                </el-tab-pane>
                <el-tab-pane :lazy=true>
                  <span slot="label"> Son İşlemlerim</span>
                  <PanelSonIslemler></PanelSonIslemler>
                </el-tab-pane>
                <!--el-tab-pane :lazy=true>
                  <span slot="label"><i class="el-icon-s-claim"></i> Talepler</span>
                  <PanelDestek></PanelDestek>
                </el-tab-pane-->
              </el-tabs>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>

import mWidget from "../../components/Pack/Genel/mWidget";
import PanelBanka from "../../components/Pack/Panel/PanelBanka";
import PanelSanalPos from "../../components/Pack/Panel/PanelSanalPos";
import PanelTakvim from "../../components/Pack/Panel/PanelTakvim";
import PanelSonIslemler from "../../components/Pack/Panel/PanelSonIslemler";
import PanelFirsat from "../../components/Pack/Panel/PanelFirsat";
import PanelDestek from "../../components/Pack/Panel/PanelDestek";
import PanelBand from "../../components/Pack/Panel/PanelBand";
import PanelTodo from "../../components/Pack/Panel/PanelTodo";
import PanelCalendar from "../../components/Pack/Panel/PanelCalendar";
import PanelGrafik from "../../components/Pack/Panel/PanelGrafik";

export default {
  components: {
    PanelGrafik,
    PanelCalendar,
    PanelTodo,
    PanelDestek,
    PanelFirsat,
    PanelSonIslemler,
    PanelTakvim,
    PanelSanalPos,
    PanelBanka,
    PanelBand,
    mWidget
  },
  data() {
    return {
      AktifTakvim: 'Tab1',
      Toplam: {
        Tahsilat: 0,
        Odeme: 0,
        Bakiye: 0,
        Site: 0,
        Bina: 0,
        Kisi: 0,
        Mesken: 0,
      },

    }
  },
  methods: {
    ToplamGetir() {
      this.$store.dispatch("Get", {path: 'panel/toplam'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Toplam = response.Toplam
          }
        });
    }
  },
  created() {
    this.ToplamGetir();
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Panel/Admin.vue